
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifestyle/news",
      function () {
        return require("private-next-pages/lifestyle/news.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifestyle/news"])
      });
    }
  